import React from "react";
import PrincipalID from "../components/molecules/PrincipalID";

export const eventKindString = (eventType: string, event: any) => {
  switch (eventType) {
    case "transferKind":
      return (
        <>
          Transfer from <PrincipalID principal={event.sender} /> to{" "}
          <PrincipalID principal={event.recipient} />
        </>
      );
    case "approveKind":
      return `Transfer from ${event.spender} approved by ${event.approver}`;
    case "initializationKind":
      return `${event.caller} initialized ${event.admin}`;
    case "creationKind":
      return `${event.deployer} deployed creation`;
    case "updateAdminKind":
      return `${event.caller} updated ${event.admin}`;
    case "mintKind":
      return (
        <>
          <PrincipalID principal={event.minter} /> minted a token
        </>
      );
    case "transferFromKind":
      return (
        <>
          <PrincipalID principal={event.spender} /> sent to{" "}
          <PrincipalID principal={event.recipient} />
        </>
      );
    default:
      return "Unknown event type";
  }
};

export const mapEventList = (eventList: Array<any>) =>
  eventList.map(({ time, eventKind }: any) => {
    const eventType = Object.keys(eventKind)[0];
    return {
      time: new Date(Number(time / 1000000n)),
      eventKind: eventKindString(eventType, eventKind[eventType]),
      amount: eventKind[eventType].amount,
    };
  });

export default eventKindString;
